import init from "./init";
import {freeTrial} from "../controllers/free-trial";

class FreeTrial {
    /* STATIC */
    public static async init(): Promise<void> {
        init.pushDelayed(freeTrial);
    }

    /* INSTANCE */
}

init.push(FreeTrial);
